import JobAdElementsManager from 'JIX/jobad/elements/ElementsManager.js';
import { setupJobtextMap } from 'JIX/jobtext_map.js';

new JobAdElementsManager();
setupJobtextMap();
